import React from 'react'
import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import { confirmVerificationCodeSuccessSelector } from 'app/selectors/user'
import { Button, IonIcon } from 'controls'
import { Divider } from 'components'
import { store } from 'services'
import { getUserProfile } from 'app/selectors'
import { image } from 'services'

import { CODE_VERIFICATION_TYPES } from './constants'
import {
  deviceHeaderStyles,
  deviceFooterStyles,
  dontShareCodeStyles,
} from './styles'

export const DeviceHeader = ({ title }) => (
  <div className="device-header">
    <img className="header-logo" src={image('icons/icon-devices.svg')} alt="" />
    <h2 className="title">
      <strong>{title}</strong>
    </h2>

    <style jsx>{deviceHeaderStyles}</style>
  </div>
)

export const DeviceFooter = ({ children }) => {
  const router = useRouter()

  function logout() {
    window.location.assign('/salir')
  }

  return (
    <>
      <Divider color="gray" />

      <div className="device-footer">
        <Button onClick={logout}>Salir</Button>
        {children}

        <style jsx>{deviceFooterStyles}</style>
      </div>
    </>
  )
}

export const DontShareCode = () => (
  <p className="security-warning">
    <IonIcon
      size="small"
      className="security-warning-icon"
      icon="md-close-circle-outline"
    />{' '}
    No compartas tu código.
    <style jsx>{dontShareCodeStyles}</style>
  </p>
)

export const SendVerificationCode = ({
  codeVerificationType = CODE_VERIFICATION_TYPES.NEW_LOGIN_DEVICE,
}) => {
  const dispatch = useDispatch()
  const { email } = useSelector(getUserProfile)
  const sendCodeFeedback = useSelector(
    store.sendVerificationCode('user').selector,
  )
  const confirmSuccess = useSelector(confirmVerificationCodeSuccessSelector)

  function sendVerificationCode() {
    dispatch(
      store.sendVerificationCode('user').action(codeVerificationType, email),
    )
    dispatch(store.confirmVerificationCode('user').clear())
  }

  return (
    <Button
      onClick={sendVerificationCode}
      disabled={!sendCodeFeedback.request || confirmSuccess}
    >
      Solicitar un código nuevo
    </Button>
  )
}
